module.exports = __webpack_public_path__ + "static/media/Dev_Spot_5.c9a669ea.webp";